import React, { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { getAccessToken, getRefreshToken } from '@ecp/common/src/utils/utils';

import NotFoundErrorPage from '../pages/error/NotFoundErrorPage';

const ClientLoginPage = lazy(() => import('../pages/co/COLoginPage'));
const ClientLogoutPage = lazy(() => import('../pages/co/COLogoutPage'));
const ClientAccountAdditionalInfoPage = lazy(() => import('../pages/co/member/AccountAdditionalInfoPage'));

const CoPublicRoutes = () => {
  const accessToken = getAccessToken();
  const refreshToken = getRefreshToken();

  return accessToken && refreshToken ? (
    <Navigate to="/" />
  ) : (
    <Routes>
      <Route path="login" element={<ClientLoginPage />} />
      <Route path="logout" element={<ClientLogoutPage />} />
      <Route path="account-additional-info" element={<ClientAccountAdditionalInfoPage />} />
      <Route path="*" element={<NotFoundErrorPage />} />
    </Routes>
  );
};

export default CoPublicRoutes;
